import { wrapRootElement as wrap } from './src/utils/root-wrapper';
export const wrapRootElement = wrap;
